
import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Environment } from '@sb/library/base';
import { Authentication } from './authentication';

interface UnauthenticatedRequestRule {
    IsMatch: (req: HttpRequest<any>) => boolean;
    Transform?: <T>(req: HttpRequest<T>) => HttpRequest<T>;
}

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {    
    private readonly _Environment = inject(Environment);

    private readonly _header = {
        'X-SchoolBox-Version': this._Environment.Version,
        'X-SchoolBox-Client-Version': this._Environment.Build
    };

    private readonly _unauthenticatedRequestRules: UnauthenticatedRequestRule[] = [{
        IsMatch: req => req.url.includes('/assets/images/') && req.url.endsWith('.svg'),
        Transform: req => req.clone({
            url: this.TrimUrlFromSegment(req.url, 'assets/'),
            responseType: 'text' as 'json'
        })
    }];

    intercept<T>(request: HttpRequest<T>, next: HttpHandler) {
        const unauthenticatedRule = this._unauthenticatedRequestRules.find(rule => rule.IsMatch(request));

        if (unauthenticatedRule) {
            request = unauthenticatedRule.Transform?.(request) ?? request;
        } else {
            request = request.clone({ headers: this.primaryHeaders });
        }

        return next.handle(request);
    }

    private TrimUrlFromSegment(url: string, segment: string): string {
        return url.substring(url.indexOf(segment));
    }

    private get primaryHeaders(): HttpHeaders {
        if (Authentication.isAuthenticated) {
            return new HttpHeaders({...this._header, Authorization: `Bearer ${Authentication.JWT}`});
        } else {
            return new HttpHeaders(this._header);
        }
    }
}
